import * as React from "react";
import List from "@material-ui/core/List";
import MenuItem from "./MenuItem";

/** Nombre del evento: lo emite cargarpedidostienda.js tras listarCompleto para avisar al menú lateral. */
export const MENU_PROD_MAS_VENDIDO_EVENT = "menuProdMasVendidoUpdated";

export default class MenuQuston extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [],
    };
  }

  componentDidMount = () => {
    // Armar menu hamburguesa
    if (this.props.path.includes("/Tienda")) {
      this.setState({ links: this.props.linksTienda });
      this.getCategoriaProducto();
    }
    /* Escucha cuando el catálogo guarda categorías en localStorage: así se repueblan los subnítems si el usuario abrió el menú antes de Cargar pedido */
    window.addEventListener(
      MENU_PROD_MAS_VENDIDO_EVENT,
      this.onMenuProdMasVendidoUpdated
    );
  };

  componentWillUnmount() {
    /* Destacar listener para evitar fugas al desmontar el menú (p. ej. al cerrar sesión o cambiar de layout) */
    window.removeEventListener(
      MENU_PROD_MAS_VENDIDO_EVENT,
      this.onMenuProdMasVendidoUpdated
    );
  }

  /** Handler del evento: vuelve a leer menu-ProdMasVendido y arma la fila "Productos" con collapse. Solo aplica si la app está en ruta Tienda. */
  onMenuProdMasVendidoUpdated = () => {
    if (!this.props.path.includes("/Tienda")) {
      return;
    }
    this.getCategoriaProducto();
  };

  getCategoriaProducto = () => {
    const datosMenu = JSON.parse(localStorage.getItem("menu-ProdMasVendido"));

    const aux = this.props.linksTienda.map((card, index) => {
      if (card.collapse) {
        return { ...card, items: datosMenu };
      } else {
        return { ...card };
      }
    });
    this.setState({ links: aux });
  };

  render() {
    //RENDERIZA EL MENÚ LATERAL EN CASO DE QUE EXISTAN SUBLINKS
    //const { match, location, history } = this.props;

    return (
      <div
        id="scrollbarMenuProducto"
        className="container"
        style={{
          paddingRight: "0px",
          zIndex: 2,
          color: "#8E95A5",
          fontFamily: "Roboto",
          fontSize: "22px",
        }}
      >
        <List
          component="nav"
          style={{
            maxHeight: "100vh",
            overflow: "auto",
            paddingBottom: "150px",
          }}
        >
          {window.location.href.includes("Tienda") &&
            this.state.links.map((item, index) => (
              <MenuItem {...item} key={index} hideMenu={this.props.hideMenu} />
            ))}
          {!window.location.href.includes("Tienda") &&
            this.props.links.map((item, index) => (
              <MenuItem {...item} key={index} hideMenu={this.props.hideMenu} />
            ))}
        </List>
      </div>
    );
  }
}
